import { GlobalMessages } from '@shared/localization/messages';
import type { ReactNode } from 'react';
import { useEffect } from 'react';

import { useToast } from '@/context/toast';
import { useMessages } from '@/hooks/messages';
import { useTenantAssetRefresh } from '@/hooks/useTenantAssetRefresh';
import { loadTenantStyles } from '@/utils/styles.ts';

import { useAuth } from '../auth';

export const TenantStyleInjector = ({ children }: { children: ReactNode }) => {
  const { tenant } = useAuth();
  const toast = useToast();
  const globalMessages = useMessages(GlobalMessages);
  // EWM-548: tenant CSS is served from a private blob via a short-lived SAS URL. If it has
  // expired the stylesheet load fails (403); re-fetch the tenant to mint a fresh URL.
  const { onAssetError, reset } = useTenantAssetRefresh();

  useEffect(() => {
    if (tenant?.cssUrl) {
      reset();
      loadTenantStyles(tenant.cssUrl, toast, globalMessages.tenantStylesNotLoaded(), onAssetError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- re-run only when the SAS cssUrl changes; toast/messages/handlers are stable enough that adding them would only cause redundant re-fetches
  }, [tenant?.cssUrl]);

  return children;
};
